import { render, staticRenderFns } from "./EditOrderStatuses.vue?vue&type=template&id=de696d56&scoped=true"
import script from "./EditOrderStatuses.vue?vue&type=script&lang=js"
export * from "./EditOrderStatuses.vue?vue&type=script&lang=js"
import style0 from "./EditOrderStatuses.vue?vue&type=style&index=0&id=de696d56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de696d56",
  null
  
)

export default component.exports